import React from "react";

function Close({ width = 20, height = 20, fill = "#C75A00" }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.1582 6.66675L9.99984 8.82508L7.8415 6.66675L6.6665 7.84175L8.82484 10.0001L6.6665 12.1584L7.8415 13.3334L9.99984 11.1751L12.1582 13.3334L13.3332 12.1584L11.1748 10.0001L13.3332 7.84175L12.1582 6.66675ZM9.99984 1.66675C5.3915 1.66675 1.6665 5.39175 1.6665 10.0001C1.6665 14.6084 5.3915 18.3334 9.99984 18.3334C14.6082 18.3334 18.3332 14.6084 18.3332 10.0001C18.3332 5.39175 14.6082 1.66675 9.99984 1.66675ZM9.99984 16.6667C6.32484 16.6667 3.33317 13.6751 3.33317 10.0001C3.33317 6.32508 6.32484 3.33341 9.99984 3.33341C13.6748 3.33341 16.6665 6.32508 16.6665 10.0001C16.6665 13.6751 13.6748 16.6667 9.99984 16.6667Z"
        fill={fill}
      />
    </svg>
  );
}

export default Close;
